var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefrigerator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refrigerator"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.875 0.75H6.125C4.26403 0.75 2.75 2.29206 2.75 4.1875V13.8125C2.75 15.7079 4.26403 17.25 6.125 17.25H12.875C14.736 17.25 16.25 15.7079 16.25 13.8125V4.1875C16.25 2.29206 14.736 0.75 12.875 0.75ZM6.125 2.125H12.875C13.9915 2.125 14.9 3.05037 14.9 4.1875V6.9375H12.875V4.875C12.875 4.4955 12.5733 4.1875 12.2 4.1875C11.8267 4.1875 11.525 4.4955 11.525 4.875V6.9375H4.1V4.1875C4.1 3.05037 5.00855 2.125 6.125 2.125ZM12.875 15.875H6.125C5.00855 15.875 4.1 14.9496 4.1 13.8125V8.3125H11.525V12.4375C11.525 12.8177 11.8267 13.125 12.2 13.125C12.5733 13.125 12.875 12.8177 12.875 12.4375V8.3125H14.9V13.8125C14.9 14.9496 13.9915 15.875 12.875 15.875Z",
    fill: "#1E1A21"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefrigerator);
export default __webpack_public_path__ + "static/media/refrigerator.852c9af83fa35feffb6b302d69332877.svg";
export { ForwardRef as ReactComponent };